import React from "react";
import DashboardCategoryFC from "../components/ClientPortal/ClientportalDashboardComponents/DashboardCategoryFC";
import DashboardStatsFC from "../components/ClientPortal/ClientportalDashboardComponents/DashboardStatsFC";
import Service from "../services";
import { AxiosError, AxiosResponse } from "axios";
import {
  GetResponseCategoreis,
  OverallPercentage,
  getQualApplicationStatusModel
} from "../models/ClientportalDashboardModels/GetResponseCategoreis";
import { BankUserContext } from "../bankUserContext";
import { clientNotes, postClientNotes } from "../models/Lead/LeadDetails";
import { catchError } from "../utils/Utils";
// import RolesAuthentication from "../Utils/RolesUtlis";
import { toast } from "react-toastify";
import FinSpinner from "../commonfields/FinSpinner";
import { APP_Config } from "../utils/AppConfig";
import { signStatus } from "../models/ClientportalDashboardModels/GetResponseCategoreis";
import { WithRouterProps, withRouter } from "../components/shared/WithRouter";
import { Col } from "reactstrap";
import ClientSideBar from "../components/layout/SideNav/ClientSidebar";
import "../scss/ClientportalDashboardMaster.scss"
import StatusTab from "../components/procpectingDetailPge/StatusTab";
import ComplianceReviewPercentage from "../components/procpectingDetailPge/ComplianceReviewPercentage";
import { CLIENT_SCREEN_TYPES } from "../utils/RoutesUtil";
import CompanySelection from "../../src/components/ClientPortal/ClientportalDashboardComponents/ClientWelcomeSurvey/ClientWelcomeSurvey";
import { FirstPge } from "../components/ClientPortal/ClientportalDashboardComponents/ClientWelcomeSurvey/FirstPage";


interface ClientPortalDashboardState {
  questionnaryData: GetResponseCategoreis;
  overallPercentage: any;
  submittedStatusData: any;
  clientNotes: clientNotes | null;
  textAreaDisable: boolean;
  pageRefresh: string;
  loader: boolean;
  iframeActivate: boolean;
  url: string;
  signStatusObject: signStatus | [],
  applicationStatusData: any;
  loginStatus: boolean;
  refreshComponent:boolean;
}

const CategoriesForSorting = [
  "Organization",
  "Identity",
  "Licensing",
  "Operations",
  "Financial",
  "Supplementary"
];
class ClientPortalDashboard extends React.Component<WithRouterProps<unknown>, ClientPortalDashboardState> {
  static contextType = BankUserContext;
  context: React.ContextType<typeof BankUserContext> | undefined;
  // roles = new RolesAuthentication;
  Service: Service;
  getComplianceOverallPercentage: any;
  locationState: any;
  constructor(props: any) {
    super(props);
    this.state = {
      questionnaryData: new GetResponseCategoreis(),
      overallPercentage: {},
      submittedStatusData: null,
      clientNotes: null,
      textAreaDisable: false,
      pageRefresh: "refresh",
      loader: false,
      iframeActivate: false,
      url: "",
      signStatusObject: [],
      applicationStatusData: null,
      loginStatus: false,
      refreshComponent:false
    };
    this.Service = new Service();
    this.locationState = this.props?.location?.state
  }



  componentDidMount() {
    this.initialRendering();
  }

  initialRendering () {
    this.getPercentage();
    this.getClientNotes();
    // this.appllicationStautsBased();
    this.context?.updateClientId(this.props?.params?.clientId)
    this.firstLogin();

    this.locationState?.editable ? this.setState({ textAreaDisable: !this.locationState?.editable }) : this.setState({ textAreaDisable: true })
  }

  refreshComponent = () =>{
    this.setState({refreshComponent:!this.state.refreshComponent})
  }

  

  componentDidUpdate(prevProps: any, prevState: any) {
    // const {updateClientId,complianceDashboardPage,updateComplainceDashboardPage} = this.context;
    if(prevState.refreshComponent !==  this.state.refreshComponent){
      this.initialRendering();
    }
    if (this.context?.complianceDashboardPage === "Approve") {
      this.submitQuestionarieHandler();
      this.context?.updateClientId(this.props?.params?.id);
      this.context?.updateComplainceDashboardPage(null);
    } else if (this.context?.complianceDashboardPage === "Decline") {
      this.getClientportalMainPageCategories();
      this.getPercentage();
      this.getClientNotes();
      this.context?.updateClientId(this.props?.params?.id);
      this.context?.updateComplainceDashboardPage(false);
    }
  }

  getSignerStatus = () => {
    // this.setState({ loader: true })
    // this.Service.getSignerStatus(
    //   "underwriter",
    //   `${APP_Config().REACT_APP_REDIRECT_LINK_IN_APP}docuSign`,
    //     this.context?.clientId
    // ).then((res: AxiosResponse<signStatus>) => this.setState({
    //   signStatusObject: res.data,
    //   loader: false,
    // }))
    // .catch((error:any) => {
    //   catchError(error, true);
    //   this.setState({ loader: false })
    // })
  }

  appllicationStautsBased = () => {
    this.getClientportalMainPageCategories();
  }

  submitQuestionarieHandler = () => {
    this.setState({ loader: true });
    this.Service.getDocusignUrl(
      this.props.params.id,
      "underwriter",
      `${APP_Config().REACT_APP_REDIRECT_LINK_IN_APP}docuSign`
    ).then((response: any) => {
      this.setState({ loader: false });
      if (response.status === 200 && response.data !== "Success") {
        this.setState({ iframeActivate: true, url: response.data });
        // toast.error("DocuSign Email Sent Successfully");
      } else {
        if (window && window.opener) {
          window.opener.postMessage(
            {
              message: "Approve or Decline success",
              from: "approveClient",
            },
            "*"
          );
          window.close();
        }
        // updateclientSidebar(true);
      }
    })
      .catch(() => {
        this.setState({ loader: false });
        // updateclientSidebar(true);
        toast.error("something went wrong");
      });
  };

  getPercentage = () => {
    this.setState({ loader: true })
    if (this.props?.params?.screenType?.toLowerCase() === CLIENT_SCREEN_TYPES.CLIENT_VIEW) {
      this.Service.getOverallPercentage(this.props.params.clientProductId).then(
        (response: AxiosResponse<OverallPercentage>) => {

          this.setState({
            overallPercentage: response.data,
            textAreaDisable: true,
            loader: false
          })
        }).catch((error: any) => {
          catchError(error, true);
          this.setState({ loader: false });
        });
    }
    if (this.props?.params?.screenType?.toLowerCase() === CLIENT_SCREEN_TYPES.COMPLIANCE_VIEW) {
      this.Service.getComplianceOverallPercentage(this.props.params.clientProductId).then(
        (response: AxiosResponse<OverallPercentage>) => {
          if (response.data?.status === "REVIEW_COMPLETED") {
            this.setState({
              overallPercentage: response.data,
              textAreaDisable: true
            })
          } else {
            this.setState({ overallPercentage: response.data })
          }
        }).catch((error: any) => {
          catchError(error, true);
          this.setState({ loader: false });
        }).finally(() => {
          this.setState({ loader: false })
        });
    }

  }

  getClientNotes = () => {
    this.props.params?.clientProductId &&
      this.Service.getClientNotes(this.props.params?.clientProductId).then((response: AxiosResponse<clientNotes>) => {
        this.setState({
          clientNotes: response.data
        })
      }).catch((error: AxiosError) => {
        catchError(error, true)
      })
  }

  getClientportalMainPageCategories = () => {
    this.setState({ loader: true })
    if (this.props?.params?.screenType?.toLowerCase() === CLIENT_SCREEN_TYPES.CLIENT_VIEW) {
      this.Service.getCategoriesByClientId(this.props.params.clientProductId).then(
        (response: AxiosResponse<GetResponseCategoreis>) => {
          response?.data?.categories.sort((a, b) => {
            if (CategoriesForSorting.indexOf(a.name) == -1) return 1;
            if (CategoriesForSorting.indexOf(b.name) == -1) return 1;
            return CategoriesForSorting.indexOf(a.name) - CategoriesForSorting.indexOf(b.name);
          })

          this.setState({
            questionnaryData: response.data,
            loader: false
          });
        }).catch((error: any) => {
          catchError(error, true);
          this.setState({ loader: false });
        });
    }
    if (this.props.params.screenType === "compView") {
      this.Service.getComplianceCategoriesByClientId(this.props.params.clientProductId).then(
        (response: AxiosResponse<GetResponseCategoreis>) => {
          response?.data?.categories.sort((a, b) => {
            if (CategoriesForSorting.indexOf(a.name) == -1) return 1;
            if (CategoriesForSorting.indexOf(b.name) == -1) return 1;
            return CategoriesForSorting.indexOf(a.name) - CategoriesForSorting.indexOf(b.name);
          })

          this.setState({
            questionnaryData: response.data,
            loader: false
          });
        }).catch((error: any) => {
          catchError(error, true);
          this.setState({ loader: false });
        });
    }


  }

  changeData = (event: any) => {
    this.setState({ clientNotes: event.target.value });
  }

  commentsSave = (event: any) => {
    const PostClientNotes: postClientNotes = {
      clientProductId: this.props.params.clientProductId,
      notes: event.target.value?.trimStart(),
    }
    this.setState({ clientNotes: event.target.value });
    this.Service.postInsertClientNotes(PostClientNotes)
      .catch((error: AxiosError) => { catchError(error, true) })
  }

  setIframeForDocuSign = (url: any) => {
    this.setState({
      iframeActivate: true,
      url
    })
  }

  firstLogin = () => {

    const data = {
      sections: "getUserLoginStatus",
      screen: "LandingPage",
      isJsonReturnObject: false,
      clientProductId: this.props?.params.clientProductId
    };

    this.Service.firstLogin(data).then((response: AxiosResponse<any>) => {
      if (response.data && response.data.length > 0) {
        this.setState({ loginStatus: response.data[0]?.loginStatus })
        if (this.props.params.screenType?.toLowerCase() !== CLIENT_SCREEN_TYPES.CLIENT_VIEW) {
          this.appllicationStautsBased();
        }
        else if (response?.data && !response.data[0]?.loginStatus) {
          this.appllicationStautsBased();
        }
      } else {
        this.appllicationStautsBased();
      }

    }).catch((error: AxiosError) => {
      catchError(error, true);
    })
  }

  renderDashboardScreens = () => {
    return (
      <>
        <DashboardStatsFC
          qustionaryData={this.state.questionnaryData}
          percentageData={this.state.overallPercentage}
          submittedStatusData={this.state.submittedStatusData}
          clientId={this.props.params.clientId}
          signStatusObject={this.state.signStatusObject}
          setIframeForDocuSign={this.setIframeForDocuSign}
          applicationStatusData={this.state.applicationStatusData}
          clientProductId = {this.props.params.clientProductId}
        />
        <DashboardCategoryFC
          categories={this.state.questionnaryData.categories}
          clientId={this.props.params.clientId}
          clientProductId={this.props.params.clientProductId}
        /> </>
    )
  }

  render() {
    return (
      <>

        <div className="container-fluid p-0">
          <React.Fragment>

            {this.state.loader ? (
              <div className="spinnerDiv">
                <FinSpinner
                />
              </div>
            ) : <></>}



            {this.state.iframeActivate ? (
              <div className="iframeContainer">
                <iframe src={this.state.url} height={1000} width="100%"></iframe>
              </div>
            ) : (
              <>
                {this.props.params.screenType?.toLowerCase() === CLIENT_SCREEN_TYPES.CLIENT_VIEW && <p className="myapplicationHeadings">Application Progress</p>}
                {
                  this.props.params.screenType?.toLowerCase() === CLIENT_SCREEN_TYPES.CLIENT_VIEW ? this.state.loginStatus ? <FirstPge refreshComponent={this.refreshComponent} /> : this.renderDashboardScreens() :
                    this.renderDashboardScreens()
                }

                {this.props.params.screenType?.toLowerCase() === CLIENT_SCREEN_TYPES.COMPLIANCE_VIEW && <div className="d-flex flex-row justify-content-center">
                  <div className="applicationNotes">
                    <h1 className="applicationNotesHeading">Application Notes</h1>
                    <textarea
                      value={this.state.clientNotes?.notes}
                      onBlur={this.commentsSave}
                      onChange={this.changeData}
                      disabled={this.state.textAreaDisable}
                    />
                  </div>
                </div>}

              </>
            )}

          </React.Fragment>
        </div>
      </>
    );
  }
}

export default withRouter<WithRouterProps<unknown>>(ClientPortalDashboard)

